module.exports = __webpack_public_path__ + "static/media/SF-3-A (1).3b2dbe6e.mp3";